module.exports = __webpack_public_path__ + "static/media/id.fbc2586e.png";